<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">{{'Report Selection' | translate | async}}</span>
    <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
  </div>
  <div class="dialog-content">
    <div class="center" [hidden]="!isLoading">
      <mat-spinner></mat-spinner>
    </div>
    <ng-container *ngFor="let item1 of reportConfigurationSubmitModel ; let i = index">
      <div *ngIf="i==0">
        <div class="search-options search-mat-column">
          <mat-form-field class="search-input">
            <input type="text" placeholder="{{Translate('Select Customer')}}" (input)="customerChanged($event)" matInput
              [matAutocomplete]="auto2" [(ngModel)]="item1.Customer" name="customrer" required>
            <mat-autocomplete [(ngModel)]="item1.Customer" #model_auto="ngModel" #auto2="matAutocomplete"
              (optionSelected)="onSelectCustomer($event.option)" name="Customer">
              <mat-option [value]="customer.Title" *ngFor="let customer of _dropDownListsFiltered.customerList">
                {{ customer.Title}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
<!-- *ngIf="RequestFromFlag==ConfigType.Alert" -->
          <mat-form-field class="search-input" >
            <mat-select (selectionChange)="jobsiteChangedAlerts($event)" [(ngModel)]="selectedJobsiteIds" name="jobsite1"
              placeholder="{{Translate('Select Job Site')}}" required multiple>
              <mat-option *ngFor="let jobsite of _dropDownListsFiltered.jobSiteList" [value]="jobsite.Id">
                {{ jobsite.Title }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- <mat-form-field class="search-input" *ngIf="RequestFromFlag==ConfigType.Fleet">
            <mat-select (selectionChange)="jobsiteChanged($event)" [(ngModel)]="item1.Jobsite" name="jobsite1"
              placeholder="{{Translate('Select Job Site')}}" required>
              <mat-option *ngFor="let jobsite of _dropDownListsFiltered.jobSiteList" [value]="jobsite">
                {{ jobsite.Title }}
              </mat-option>
            </mat-select>
          </mat-form-field> -->

       
            <mat-form-field class="header-form-full-width" >
              <mat-chip-list #FamilychipList>
                <mat-chip *ngFor="let family of selectedFamilies" [selectable]="true" [removable]="true"
                  (removed)="removeFamily(family)">
                  {{ family.Title }}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
                <input placeholder="Select Family" #familychipInput [matAutocomplete]="autoFamily"
                  [matChipInputFor]="FamilychipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  (input)="filterFamilies($event.target.value)" name="family" ngDefaultControl />
              </mat-chip-list>
              <mat-autocomplete #autoFamily="matAutocomplete" (optionSelected)="selectFamily($event)">
                <mat-option *ngFor="let family of this._dropDownListsFiltered.familyList" [value]="family.Title">
                  {{ family.Title }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <div style="margin-left: 44%;" *ngIf="isModalLoader ">
              <mat-spinner diameter="30"> </mat-spinner>
            </div>
          

          <mat-form-field class="search-input" *ngIf="!isModalLoader ">
            <mat-chip-list #modelChipList>
              <!-- Loop through the selected models and display each model as a chip -->
              <mat-chip *ngFor="let model of selectedModels" [selectable]="true" [removable]="true"
                (removed)="removeModel(model)">
                {{ model.Title }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
              <!-- Input field to filter and add Models -->
              <input placeholder="Select Model" #modelInput [matAutocomplete]="autoModel"
                [matChipInputFor]="modelChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="true" (input)="filterModels($event.target.value)" name="customer8"
                ngDefaultControl />
            </mat-chip-list>
            <!-- Auto-complete dropdown for available Models -->
            <mat-autocomplete #autoModel="matAutocomplete" (optionSelected)="selectModel($event)">
              <mat-option *ngFor="let model of _dropDownListsFiltered.modelList" [value]="model">
                {{ model.Title }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field class="search-input" *ngIf="RequestFromFlag==ConfigType.Fleet">
            <mat-chip-list #modelChipList>
              <!-- Loop through the selected models and display each model as a chip -->
              <mat-chip *ngFor="let model of selectedUnitNumbers" [selectable]="true" [removable]="true"
                (removed)="removeUnitNumber(model)">
                {{ model.UnitNumber }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>

              <!-- Input field to filter and add Models -->
              <input placeholder="Select Unit Number" #unitInput [matAutocomplete]="autoModel"
                [matChipInputFor]="modelChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="true" (input)="filterUnitNumbers($event.target.value)" name="customer8"
                ngDefaultControl />
            </mat-chip-list>

            <!-- Auto-complete dropdown for available Models -->
            <mat-autocomplete #autoModel="matAutocomplete" (optionSelected)="selectUnitNumber($event)">
              <mat-option *ngFor="let unit of unitDataFiltered" [value]="unit">
                {{ unit.UnitNumber }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <div style="text-align: right;margin:5px" *ngIf="RequestFromFlag==ConfigType.Fleet">
            <button mat-raised-button color="warn" (click)="reset()">
                       {{'Reset' | translate | async}}

            </button>
          </div>
        </div>
      </div>

    </ng-container>

    <div class="maindiv">
      <div *ngFor="let item of reportConfigurationSubmitModel; let i = index" style="background-color: white;">
        <div class="dropzone" draggable="true" (dragstart)="drag($event)" (drop)="drop($event)"
          (dragover)="allowDrop($event)" attr.id="{{item.id}}"
          style="border-style: solid; border-width: 1px; padding-top: 10px; padding-right: 12px; padding-bottom: 5px; padding-left: 12px; border-top: 0px;">
          <div style="display: flex; flex-direction: row; align-items: center;">
            <div style="margin-right: 12px;">
              <div style="align-self: center;" *ngIf="item.IsReportChek">
                <i class="material-icons" (click)="CheckBoxselect(item,1)" style="cursor: pointer; color: green;">
                  check_box
                </i>
              </div>
              <div style="align-self: center;" *ngIf="!item.IsReportChek ">
                <i class="material-icons" (click)="CheckBoxselect(item,0)" style="cursor: pointer;color: red;">
                  disabled_by_default
                </i>
              </div>
              <!-- <mat-checkbox [checked]="item.InspectInReverse" [(ngModel)]="item1.jobsite"
              (change)="setInspectInRevrseFlag(item.id, $event)"></mat-checkbox> -->
            </div>
            <div class="comparttype">{{item.ReportSectionName | translate | async}}</div>
            <div style="display: flex; flex-direction: row; justify-content: flex-end;">
              <div>
                {{item.id}}
                <span title="Move up" style="margin-right: 16px!important; cursor: pointer;"
                  [class.button-hide]="item.SortOrder==1?true:false" (click)="recalculateSortOrder(item ,i,1)">
                  <i class="material-icons" style="font-weight: bolder;font-size: 33px;">arrow_upward</i>
                </span>
              </div>
              <div>
                <span title="Move down" style="margin-right: 16px!important;cursor: pointer;"
                  [class.button-hide]="item.SortOrder>reportConfigurationSubmitModel.length-1?true:false"
                  (click)="recalculateSortOrder(item, i,0)">
                  <i class="material-icons" style="font-weight: bolder;font-size: 33px;">arrow_downward</i>
                </span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="sepbutton">
    <button class="white-button" mat-raised-button (click)="onCloseClick()">
      {{
      'Cancel' |
      translate | async
      }}
    </button>
    <a class="button button--primary"  *ngIf="RequestFromFlag==ConfigType.Fleet" (click)="printPDF()" title="Click to get filtered data in CSV format.">
      <i class="material-icons button__icon">download</i><span class="button__text">PDF</span>
    </a>
  </div>
</div>